// Clans excluded from the Family Ranking leaderboard shown in the admin panel.
export const EXCLUDED_FAMILY_CLAN_IDS = [
  "CLAN866231", // ᴠɪʙᴇ-ᴄsʀ ᴛᴇᴀᴍ
];
